import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const RouteSwitch = ({ children }, context) => {
  const { match, location } = context.router.route;
  const path = location.pathname;
  const { url } = match;

  return (
    <Switch>
      {children}
      {(!path.includes('not-found') && url !== path) && <Redirect to="/not-found" />}
    </Switch>
  );
};

export default RouteSwitch;

RouteSwitch.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired
};

RouteSwitch.contextTypes = {
  router: PropTypes.shape({
    route: PropTypes.object.isRequired
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/components/RouteSwitch/RouteSwitch.js